import  store from '../../../store'
import general from "@/wl-core/helpers/general";

export class DeptDetails {
    constructor(obj) {
        this.PartnerMvItm_ID = obj.PartnerMvItm_ID;
        this.PartnerMove_ID = obj.PartnerMove_ID;
        this.Partner_ID = obj.Partner_ID;
        this.Branch_ID = obj.Branch_ID;
        this.DateInvoice = obj.DateInvoice;
        this.NumberPar = obj.NumberPar;
        this.InvoiceDescr = obj.InvoiceDescr;
        this.Description = obj.Description;
        this.Balance = general.round(obj.Balance);
        this.StandBy = obj.StandBy;
        this.BranchAddress = null;
        this.BranchAreaName = null;
        this.PartnerBrandName = obj.PartnerBrandName;
        this.PendingAmount = obj.PendingAmount || 0
        this.setBranch();
        this.setStatusName();
    }

    getBalance(){
        return this.Balance - this.PendingAmount
    }
    setStatusName(){
        this.StatusName = this.StandBy?'Σε αναμονή':'Εκδόθηκε'
    }
    setBranch(){
       const branch = store.getters['branch'](this.Branch_ID);
       if(branch){
           this.BranchAddress = branch.BranchAddress;
           this.BranchAreaName = branch.BranchAreaName;
           this.FullBranch = this.BranchAddress+', '+this.BranchAreaName;

       }
    }

}
